module.exports = __webpack_public_path__ + "static/media/loader.4ffa712b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/loading/loader.svg
// module id = 179
// module chunks = 0